<template>
  <div class="HonoraryCertificate">
    <div class="HonoraryCertificate_content">
      <div class="HonoraryCertificate_left">
        <div class="TechnicalBar">
          <el-menu
            :default-active="tabIndex"
            mode="horizontal"
            active-text-color="#2968BD"
          >
            <el-menu-item
              :index="index"
              v-for="(item, index) in rylist"
              :key="index"
              @click="changeItem(index)"
            >
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <div class="HonoraryCertificate_right">
        <div class="HonoraryCertificate_title">
          <el-divider>
            <div class="HonoraryCertificate_title_name">{{ tabName }}</div>
          </el-divider>
        </div>
        <div class="HonoraryCertificate_image" v-if="this.tabIndex == 0">
          <div
            class="HonoraryCertificate_image_item"
            v-for="(item, index) in pagelist[pagenum1]"
            :key="index"
          >
            <div class="HonoraryCertificate_image_item1">
              <img :src="item.imageUrl" />
            </div>
            <div class="HonoraryCertificate_image_item1_name">
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="paging_flex_row">
            <Paging
              :total="total1"
              :page-size="pageSize"
              :current-page="pageNumber1"
              @onPageChange="onPageChange1"
            ></Paging>
          </div>
        </div>
        <div class="HonoraryCertificate_image" v-if="this.tabIndex == 1">
          <div
            class="HonoraryCertificate_image_item"
            v-for="(item, index) in pagelist2[pagenum2]"
            :key="index"
          >
            <div class="HonoraryCertificate_image_item2">
              <img :src="item.imageUrl" />
            </div>
            <div class="HonoraryCertificate_image_item1_name">
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="paging_flex_row">
            <Paging
              :total="total2"
              :page-size="pageSize"
              :current-page="pageNumber2"
              @onPageChange="onPageChange2"
            ></Paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getHonorInfoApi } from "@/api/index";
import Paging from "./components/Paging";
export default {
  data() {
    return {
      ryTypeList: [],
      zlTypeList: [],
      rylist: [{ name: "荣誉资质" }, { name: "专利著作" }],
      tabName: "荣誉资质",
      tabIndex: 0,
      pageSize: 6,
      total1: 0,
      total2: 0,
      pageNumber1: 1,
      pageNumber2: 1,
      pagenum1: 0,
      pagenum2: 0,
      pagelist: [],
      pagelist2: [],
    };
  },
  created() {
    this.tabIndex = 0;
  },
  mounted() {
    this.getHonorInfo();
  },
  components: { Paging },
  methods: {
    onPageChange1(val) {
      this.pageNumber1 = val;
      this.pagenum1 = this.pageNumber1 - 1;
      console.log(this.pagenum1);
    },
    onPageChange2(val) {
      this.pageNumber2 = val;
      this.pagenum2 = this.pageNumber2 - 1;
    },
    changeItem(index) {
      this.tabIndex = index.toString();
      if (index == 0) {
        this.tabName = "荣誉资质";
      } else {
        this.tabName = "专利著作";
      }
      console.log(this.tabIndex);
    },
    //获取荣誉资质
    getHonorInfo() {
      // const data =
      // {
      //   pageSize : this.pageSize
      // }
      getHonorInfoApi().then((res) => {
        console.log(res);
        this.ryTypeList = res.data.ryTypeList;
        this.zlTypeList = res.data.zlTypeList;
        this.total1 = res.data.ryTypeList.length;
        this.total2 = res.data.zlTypeList.length;
        for (let i = 0; i < this.ryTypeList.length; i += 6) {
          this.pagelist.push(this.ryTypeList.slice(i, i + 6));
        }
        for (let i = 0; i < this.zlTypeList.length; i += 6) {
          this.pagelist2.push(this.zlTypeList.slice(i, i + 6));
        }
        console.log(this.pagelist);
      });
    },
  },
};
</script>
<style scoped>
.HonoraryCertificate {
  width: 1200px;
  margin: 0 auto;
}
.HonoraryCertificate_content {
  display: flex;
  padding-bottom: 50px;
}
.HonoraryCertificate_left {
  padding-top: 120px;
}
.HonoraryCertificate_right {
  padding-left: 65px;
  width: 100%;
}
.HonoraryCertificate_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 35px;
  /*width: 1025px;*/
  width: 100%;
}
.HonoraryCertificate_title_name {
  font-size: 28px;
  text-align: center;
  font-weight: 600;
}
.HonoraryCertificate_image {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  width: 1200px;
  width: 100%;
}
.HonoraryCertificate_image_item1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 35px 15px;
  border: 1px solid #e5e5e5;
  width: 280px;
  height: 207px;
}
.HonoraryCertificate_image_item2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 35px 15px;
  border: 1px solid #e5e5e5;
  width: 282px;
  height: 352px;
}
.HonoraryCertificate_image_item2 img {
  width: 250px;
  height: 340px;
}
.HonoraryCertificate_image_item1 img {
  width: 235px;
  height: 154px;
}
.HonoraryCertificate_image_item1_name {
  text-align: center;
  font-size: 16px;
  color: #333333;
}
.el-menu {
  border-bottom: none;
  width: 140px;
}
.TechnicalBar >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-right: 2px solid #2968bd;
  border-bottom: none;
}
.TechnicalBar >>> .el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  width: 140px;
}
.TechnicalBar >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
  /*border-right: 1px solid #E5E5E5;*/
  display: flex;
  flex-direction: column;
  align-items: end;
}
.paging_flex_row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
/*.HonoraryCertificate {*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  flex-direction: column;*/
/*  width: 1200px;*/
/*  padding-bottom: 160px;*/
/*}*/
/*.Dynamic_title_name {*/
/*  font-weight: 400;*/
/*  text-align: center;*/
/*  font-size: 26px;*/
/*  color: #333333;*/
/*}*/
/*.Dynamic_title_text {*/
/*  text-align: center;*/
/*  font-size: 14px;*/
/*  color: #333333;*/
/*}*/
/*.HonoraryCertificate_content {*/
/*  width: 1200px;*/
/*}*/
/*.HonoraryCertificate_content_title{*/
/*  padding-bottom: 80px;*/
/*}*/

/* .HonoraryCertificate_content_img { */
/*display: flex;*/
/*justify-content: start;*/
/*align-items: center;*/
/*!*flex-direction: column;*!*/
/*flex-wrap: wrap;*/
/*!*width: 85%;*!*/
/*!*padding-bottom: 20px;*!*/
/*!*margin-left: 100px;*!*/
/*width: 1200px;*/
/*width: 100%;*/
/* } */
/*.HonoraryCertificate_content_img1 {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  justify-content: center;*/
/*  width: 280px;*/
/*  padding-left: 20px;*/
/*  !*margin-bottom: 76px;*!*/
/*}*/
/*.HonoraryCertificate_content_img_item {*/
/*  margin: 35px 0;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  !*flex-direction: column;*!*/
/*  border: 1px solid #E5E5E5;*/
/*  width: 280px;*/
/*  height: 207px;*/
/*}*/
/*.HonoraryCertificate_content_img_item img,.HonoraryCertificate_content1_img img{*/
/*  width: 235px;*/
/*  height: 154px;*/
/*}*/
/*.HonoraryCertificate_content_img1_name span {*/
/*  font-size: 16px;*/
/*  color: #333333;*/
/*}*/

/*.HonoraryCertificate_content1 {*/
/*  padding-top: 100px;*/
/*  width: 1200px;*/
/*}*/
/*.HonoraryCertificate_content1_title{*/
/*  padding-bottom: 80px;*/
/*}*/

/*.HonoraryCertificate_content1_img {*/
/*  display: flex;*/
/*  justify-content: start;*/
/*  align-items: center;*/
/*  !*flex-direction: column;*!*/
/*  flex-wrap: wrap;*/
/*  !*width: 85%;*!*/
/*  !*padding-bottom: 20px;*!*/
/*  !*margin-left: 100px;*!*/
/*  width: 1200px;*/
/*  width: 100%;*/
/*}*/
/*.HonoraryCertificate_content1_img1 {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  justify-content: center;*/
/*  width: 280px;*/
/*  padding-left: 20px;*/
/*  !*margin-bottom: 76px;*!*/
/*}*/
/*.HonoraryCertificate_content1_img_item {*/
/*  margin: 35px 0;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  !*flex-direction: column;*!*/
/*  border: 1px solid #E5E5E5;*/
/*  width: 280px;*/
/*  height: 350px;*/
/*}*/
/*.HonoraryCertificate_content1_img_item img*/
/*{*/
/*  width: 250px;*/
/*  height: 340px;*/
/*}*/
/*.HonoraryCertificate_content1_img1_name span {*/
/*  font-size: 16px;*/
/*  color: #333333;*/
/*}*/

/*.el-divider__text.is-center {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/HonoraryCertificate.vue